import { Box, Container, Grid } from "@mui/material";
import { StepConfig } from "assets/data";
import { Custom, Item } from "components";
import { useTheme } from "contexts";
import { StepType } from "types";

export const Footnote = () => {
  const { theme } = useTheme();

  return (
    <Box bgcolor={theme.color.primary.color} py={theme.spacing.xxxl}>
      <Container>
        <Grid container>
          <Grid item xs={12}>
            <Custom.Typography
              size={theme.font.md}
              weight={theme.font.semiBold}
            >
              How does it work?
            </Custom.Typography>
            <Grid container spacing={theme.spacing.md}>
              {StepConfig.map((item: StepType, i: number) => (
                <Grid key={i} item xs={12} sm={6} md={3}>
                  <Item.Step step={i + 1} {...item} />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};
